module.exports = __webpack_public_path__ + "img/gq.5c6afaa.svg";